var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout--full-page"},[_c('VuePerfectScrollbar',{staticClass:"w-full h-full",attrs:{"settings":_vm.scrollbarSettings}},[_c('transition',{attrs:{"name":_vm.routerTransition}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }